<div class="header--update-info" *ngIf="countdownMessage">
    <p class="message-info m-0"><span>The new version of the website will be released in&nbsp;</span><span class="font-weight-bold">{{countdownMessage}}</span></p>
    <button class="btn btn-link btn-update" (click)="reload()">Update Now</button>
</div>
